export const defaultImg = {
  id: null,
  preview: '',
  file: null,
  loading: false,
}

export const defaultDialogueButton = {
  buttonName: '',
  linkType: 'custom',
  linkName: '',
  sportId: '',
  link: [],
  id: '',
}

export const defaultBannerRedirect = {
  isRedirectAvailable: false,
  redirectType: 'link',
  linkRedirect: {
    linkType: 'custom',
    linkName: '',
    sportId: '',
    link: [],
    id: '',
  },
  dialogueRedirect: {
    img: {
      ...defaultImg,
    },
    title: '',
    text: '',
    description: '',
    isDialogueButtonAvailable: false,
    dialogueButton: {
      ...defaultDialogueButton,
    },
  },
}

export const BANNER_CONTENT_FORM_FIELDS = {
  bannerImg: {
    ...defaultImg,
  },
  redirect: {
    ...defaultBannerRedirect,
  },
}
